import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { TrendingUp, TrendingDown } from 'lucide-react'

export function StatCard({
  title,
  value,
  description,
  subDescription,
  icon: Icon,
  trend,
  trendValue,
  className,
  valueClassName,
  contentClassName,
}) {
  const TrendIcon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : null

  return (
    <Card className={cn("", className)}>
      <CardContent className={cn("p-6", contentClassName)}>
        <div className="flex items-center justify-between mb-3">
          <span className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground">
            {Icon && <Icon className="h-4 w-4 shrink-0" />}
            {title}
          </span>
          {trend && trendValue && (
            <div className={cn(
              "flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full",
              trend === 'up' 
                ? "text-emerald-700 bg-emerald-50" 
                : trend === 'down' 
                  ? "text-red-700 bg-red-50" 
                  : "text-muted-foreground bg-muted"
            )}>
              {TrendIcon && <TrendIcon className="h-3 w-3" />}
              <span>{trendValue}</span>
            </div>
          )}
        </div>
        
        <div className={cn("text-3xl font-bold tracking-tight", valueClassName)}>
          {value}
        </div>
        
        {(description || subDescription) && (
          <div className="mt-2 space-y-0.5">
            {description && (
              <p className="text-sm text-muted-foreground flex items-center gap-1">
                {description}
                {trend === 'up' && <TrendingUp className="h-3 w-3 text-emerald-600" />}
                {trend === 'down' && <TrendingDown className="h-3 w-3 text-red-600" />}
              </p>
            )}
            {subDescription && (
              <p className="text-xs text-muted-foreground">
                {subDescription}
              </p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export function StatCardGroup({ children, className }) {
  return (
    <div className={cn("grid gap-4 md:grid-cols-2 lg:grid-cols-4", className)}>
      {children}
    </div>
  )
}

export default StatCard
